import { Fragment } from 'react';
import styles from './table-skeleton.module.scss';

interface ITableSkeleton {
	isLoading: boolean;
	columnsAmount?: number;
	rowsAmount?: number;
}

export const SkeletonCell = () => {
	return <div className={styles.rectangle}></div>;
};

export const TableSkeleton = (props: ITableSkeleton) => {
	const { isLoading, columnsAmount = 5, rowsAmount } = props;

	if (!isLoading) {
		return null;
	}

	const rows = Array.from(new Array(rowsAmount || 5));
	const columns = Array.from({ length: columnsAmount });
	return (
		<Fragment>
			{rows.map((row, rowIndex) => {
				return (
					<tr key={rowIndex} className={styles.row}>
						{columns.map((column, columnIndex) => {
							return (
								<td key={columnIndex} className={styles.cell}>
									<SkeletonCell />
								</td>
							);
						})}
					</tr>
				);
			})}
		</Fragment>
	);
};
